module.exports = __webpack_public_path__ + "img/gb.3663af84.png";